import styles from './contact.module.scss'

import React, { useEffect, useState } from 'react'

import { createClickedSegmentEvent } from 'Clutch/Utilities/Instrumentation/Impressions/impressionSegmentEvents'

import ContactUsCard from 'Clutch/Organisms/ContactUsCard/ContactUsCard'

import Button from 'Clutch/Molecules/Button'

import Card from 'Clutch/Atoms/Card'
import Svg from 'Clutch/Atoms/Svg'
import Typography from 'Clutch/Atoms/Typography'

const Contact = ({}) => {
  const [browserDate, setBrowserDate] = useState(null)
  useEffect(() => setBrowserDate(new Date()), [])

  return (
    <div className={`${styles.contact_card} ${browserDate ? '' : styles.contact_card_pending}`}>
      <ContactUsCard mockDate={browserDate ?? new Date(0)} />
    </div>
  )
}

export default Contact
